module.exports = __webpack_public_path__ + "img/faq.3dcb39a8.svg";